import type { StepType } from "@reactour/tour";
import TourStepContent from "./wrapper";
import { text } from "@quickpoint.me/shared";

const viewerAccessibility: StepType[] = [
	{
		selector: "window",
		content: () => (
			<TourStepContent
				description={() => (
					<span>
						<strong>{text.tourSteps.a11yViewerHeading}</strong>
						<br />
						<br />
						{text.tourSteps.a11yViewerIntro}
					</span>
				)}
			/>
		),
		position: "center",
	},
	{
		selector: "window",
		content: () => (
			<TourStepContent
				description={() => (
					<span>
						<strong>{text.tourSteps.a11yViewerColorsHeading}</strong>
						<br />
						<br />
						{text.tourSteps.a11yViewerColors}
					</span>
				)}
			/>
		),
		position: "center",
	},
	{
		selector: "window",
		content: () => (
			<TourStepContent
				description={() => (
					<span>
						<strong>{text.tourSteps.a11yViewerReadabilityHeading}</strong>
						<br />
						<br />
						{text.tourSteps.a11yViewerNdrFont}
						<br />
						<br />
						{text.tourSteps.a11yViewerRuler}
						<br />
						<br />
						{text.tourSteps.a11yViewerTint}
					</span>
				)}
			/>
		),
		position: "center",
	},
	{
		selector: "window",
		content: () => (
			<TourStepContent
				description={() => (
					<span>
						<strong>{text.tourSteps.a11yViewerTextSizeHeading}</strong>
						<br />
						<br />
						{text.tourSteps.a11yViewerTextSize}
						<br />
						<br />
						<strong>{text.tourSteps.a11yViewerDisplayHeading}</strong>
						<br />
						<br />
						{text.tourSteps.a11yViewerDisplay}
						<br />
						<br />
						{text.tourSteps.a11yViewerPdf}
					</span>
				)}
			/>
		),
		position: "center",
	},
];

export default viewerAccessibility;
